import * as React from 'react';
import Section from '../Section';
import { useEffect, useState } from 'react';
import {HeaderContext, RingsSpinner} from '@weddingspot/ws-core-components';
import { HOGAN_CONFIG } from '../../../constants/config';


export interface WeddingSpacesData {
    basicProfile?: {
        socialTablesEnabled: boolean;
        socialTablesProviderId: string;
    };
}

interface Props {
    csnVenueData?: WeddingSpacesData;
    onSectionExpanded: (name: string) => void;
}

const socialTableBaseURL = HOGAN_CONFIG.social_tables.csn_integration.base_url;

const styles = require('./WeddingSpaces.scss');

const WeddingSpaces = (props: Props) => {
    const [showSection, setShowSection] = useState(false);
    const [iframeLoaded, setIframeLoaded] = useState(false);
    const [STSuccess, setSTSuccess] = useState<boolean>();
    const [STUrl, setSTUrl] = useState<string>();

    function checkForChromeEdgeOperaBrowsers(){
        const userAgent = navigator.userAgent;
        if (userAgent.includes("Opera") || userAgent.includes("OPR") || userAgent.includes("Edg") || userAgent.includes("Chrome")) {
            return true;
        } else {
            return false;
        }
    }

    const { nonceValue } = React.useContext(HeaderContext);
    useEffect(() => {
        if (props.csnVenueData?.basicProfile?.socialTablesEnabled && props.csnVenueData?.basicProfile?.socialTablesProviderId) {
            setShowSection(true);

            const url =
                `${socialTableBaseURL}properties/${props.csnVenueData?.basicProfile?.socialTablesProviderId}/presentation-layer` +
                `?removeRFI=1&removeFilters=1&removeCheckboxes=1&hideRoomDetails=1&primaryColor=881155&embeddedOnCSN=1`;
            setSTUrl(url);

            let STchecker;
            if(checkForChromeEdgeOperaBrowsers()){
                STchecker = document.createElement('link');
                STchecker.href = url;
                STchecker.rel = 'prefetch';
            } else {
                STchecker = document.createElement('script');
                STchecker.type = 'text/javascript';
                STchecker.nonce = `${nonceValue}`;
                STchecker.src = url;
            }
            STchecker.onload = () => {
                setSTSuccess(true);
            };
            STchecker.onerror = () => {
                setSTSuccess(false);
                setShowSection(false);
            };
            document.head.append(STchecker);
        }
    }, [props.csnVenueData]);

    return showSection ? (
        <>
            <Section
                onSectionExpanded={() => {
                    props.onSectionExpanded('Wedding Spaces');
                }}
                title='Wedding Spaces'
                isExpanded={true}
                forceHide={true}
            >
                <div className={styles.wrapper}>
                    {(!iframeLoaded || STSuccess === undefined) && (
                        <div className={styles.spinnerContainer}>
                            <RingsSpinner animate={true} />
                        </div>
                    )}
                    <iframe
                        className={styles.iframe}
                        onLoad={() => {
                            setIframeLoaded(true);
                        }}
                        src={STUrl}
                    />
                </div>
            </Section>
            <div className='VenuePage--additional-details-separator' />
        </>
    ) : null;
};

export default WeddingSpaces;
